import { Badge } from "../../components/ui/Badge";
import type {
	CartIntent,
	RebalanceIntent,
	WithdrawIntent,
} from "../../lib/cartStore";
import { formatUsdcRaw, shortAssetId } from "../../lib/format";
import { RemoveButton } from "./RemoveButton";

export function IntentRow({
	intent,
	onRemove,
}: {
	intent: CartIntent;
	onRemove: () => void;
}) {
	if (intent.kind === "withdraw")
		return <WithdrawRow intent={intent} onRemove={onRemove} />;
	return <RebalanceRow intent={intent} onRemove={onRemove} />;
}

function WithdrawRow({
	intent,
	onRemove,
}: {
	intent: WithdrawIntent;
	onRemove: () => void;
}) {
	return (
		<div className="flex items-center justify-between gap-2 rounded-md border border-slate-800 bg-slate-950/60 px-3 py-2 text-xs">
			<div className="min-w-0">
				<div className="flex items-center gap-2">
					<Badge tone="negative">withdraw</Badge>
					<span className="font-mono text-slate-200">
						{shortAssetId(intent.assetId, 22)}
					</span>
				</div>
				<p className="mt-0.5 text-[11px] text-slate-400">
					{intent.protocol} · {formatUsdcRaw(intent.valueUsdcRaw)}
				</p>
			</div>
			<RemoveButton onClick={onRemove} />
		</div>
	);
}

function RebalanceRow({
	intent,
	onRemove,
}: {
	intent: RebalanceIntent;
	onRemove: () => void;
}) {
	const legs = Object.values(intent.deltas).filter(
		(v) => BigInt(v) !== 0n,
	).length;
	return (
		<div className="flex items-center justify-between gap-2 rounded-md border border-slate-800 bg-slate-950/60 px-3 py-2 text-xs">
			<div className="min-w-0">
				<div className="flex items-center gap-2">
					<Badge tone="positive">rebalance</Badge>
					<span className="text-slate-200">
						{legs} leg{legs === 1 ? "" : "s"}
					</span>
				</div>
				<p className="mt-0.5 text-[11px] text-slate-400">
					Δ APY {intent.apyDeltaPct} · net{" "}
					{formatUsdcRaw(intent.netBenefitUsdcRaw)}
				</p>
			</div>
			<RemoveButton onClick={onRemove} />
		</div>
	);
}
